export default "__VITE_ASSET__7af48d86__"